import Vue from 'vue'
import Vuetify, { VLayout } from 'vuetify/lib'
import '@/assets/style/app.styl' // Override the font
import { Scroll } from 'vuetify/lib/directives'
import LeaplyLock from '@/components/icons/LeaplyLock'

Vue.use(Vuetify, {
  customProperties: true,
  components: { VLayout },
  directives: { Scroll },
  iconfont: 'mdi',
  theme: {
    accent: '#F5B427',
    dark: '#424242',
    error: '#DB212A',
    info: '#78d5fb',
    muted: '#ADADAD',
    primary: '#FD690F',
    secondary: '#2645b9',
    success: '#30B58F',
    warning: '#F5B427',
  },
  icons: {
    'leaply-lock': { component: LeaplyLock },
  },
})
